import { useTranslation } from 'react-i18next';

const ICONS = [
  'ri-user-star-line',
  'ri-building-line',
  'ri-price-tag-3-line',
  'ri-route-line',
  'ri-team-line',
];

const CONTENTS_COUNT = 5;

export default function Contents() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('corporateBrochure.contents.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateBrochure.contents.title')}
          </h2>
          {String(t('corporateBrochure.contents.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporateBrochure.contents.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[700px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: CONTENTS_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="card-glow group bg-background-100/60 border border-background-200/60 p-6"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/[0.06] mb-4 group-hover:bg-accent-500/[0.12] transition-colors duration-300">
                <i className={`${ICONS[idx]} text-accent-500 text-lg`}></i>
              </div>
              <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-1">
                {t(`corporateBrochure.contents.${idx}.title`)}
              </h3>
              <p className="text-[13px] text-accent-500/70 tracking-[0.08em] mb-3 font-label">
                {t(`corporateBrochure.contents.${idx}.titleEn`)}
              </p>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(`corporateBrochure.contents.${idx}.desc`)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <div className="max-w-[700px] bg-background-100/60 border border-background-200/60 p-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full bg-accent-500/[0.06]">
                <i className="ri-information-line text-accent-500 text-lg"></i>
              </div>
              <div>
                {String(t('corporateBrochure.contents.notice')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">{__s}</p>))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
